<!-- =========================================================================================
    File Name: VxTour.vue
    Description: Tour Component
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <v-tour name="vuesaxTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step v-if="tour.currentStep === index"
                  v-for="(step, index) of tour.steps"
                  :key="index"
                  :step="step"
                  :previous-step="tour.previousStep"
                  :next-step="tour.nextStep"
                  :stop="tour.stop"
                  :is-first="tour.isFirst"
                  :is-last="tour.isLast"
                  :labels="tour.labels">

            <div slot="actions" class="flex justify-center">
              <vs-button size="small"
                         class="mr-3"
                         @click="Stopped(),Completed()"
                         icon-pack="feather"
                         icon="icon-x"
                         icon-after
                         color="#fff"
                         type="border"
                         v-if="tour.currentStep != tour.steps.length - 1">
                Skip
              </vs-button>

              <vs-button size="small"
                         @click="tour.previousStep"
                         icon-pack="feather"
                         icon="icon-chevrons-left"
                         color="#fff"
                         type="border"
                         class="mr-3"
                         v-if="tour.currentStep">
                Previous
              </vs-button>

              <vs-button size="small"
                         @click="Next"
                         icon-pack="feather"
                         icon="icon-chevrons-right"
                         icon-after
                         color="#fff"
                         type="border"
                         class="btn-tour-next"
                         v-if="tour.currentStep != tour.steps.length - 1">
                Next
              </vs-button>

              <vs-button size="small"
                         @click="Stopped(),Completed()"
                         icon-pack="feather"
                         icon="icon-check-circle"
                         icon-after
                         color="#fff"
                         type="border"
                         class="btn-tour-finish"
                         v-if="tour.currentStep == tour.steps.length - 1">
                Finish
              </vs-button>
            </div>

          </v-step>
        </transition>
      </template>
    </v-tour>
</template>

<script>

export default{
    name: 'vx-tour',
    props: {
      steps: {
        required: true,
        type: Array,
      },
      active: true
    },
    watch: {
      '$route.path'() {
      },
      'active'(newVal,oldVal) {
        if (newVal == true) {
          this.StartTour();
        }
        else {
          this.Stopped();
        }
      }
    },
    mounted() {
      if (this.active) {
        this.StartTour();
      }
      
    },
    methods:{
      Next() {
        this.$emit("NextStep", this.$tours['vuesaxTour'].currentStep);
        this.$tours['vuesaxTour'].nextStep();
        if (this.$tours['vuesaxTour'].steps[this.$tours['vuesaxTour'].currentStep -1].before) {
          this.$tours['vuesaxTour'].steps[this.$tours['vuesaxTour'].currentStep].before();
        }
      },
      StartTour() {
        this.$tours['vuesaxTour'].start();
        this.$emit("TourStarted");
      },
      Prev() {
        this.$emit("PreviousStep", this.$tours['vuesaxTour'].currentStep);
        if (this.$tours['vuesaxTour'].steps[this.$tours['vuesaxTour'].currentStep + 1].before) {
          this.$tours['vuesaxTour'].steps[this.$tours['vuesaxTour'].currentStep].before();
        }
        this.$tours['vuesaxTour'].previousStep();
      },
      Stopped() {
        this.$tours['vuesaxTour'].stop();
        this.$emit("TourStopped");
      },
      Completed() {
        this.$emit("TourCompleted");
      },
      Started() {
        this.$emit("TourStarted");
      }
    }
}
</script>

<style lang="scss">
.v-tour {
    .v-step {
        z-index: 99999;
        background-color: var(--primary);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));
        position: absolute;

        .v-step__arrow {
            border-color: var(--primary);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }
    }
}
</style>
